import { SUPPORT_EMAIL_ADDRESS } from '@constants/common'

import { useActiveCompany } from './useActiveCompany'

/**
 * Where the active company's user writes to us.
 *
 * The backend picks the address from the service type and serves it per company, so a user
 * holding both kinds of company gets the right one for whichever is open. The constant is the
 * fallback for the surfaces that render before a company is known - the error screens.
 */
export function useSupportEmail(): string {
  return useActiveCompany()?.support_email || SUPPORT_EMAIL_ADDRESS
}
